module.exports = {
      id: "live-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg-sprite-f2ca7f9d4080f6eed262da64a41d98e9.svg#live",
      toString: function () {
        return this.url;
      }
    }